import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSectionHeader from '@/views/my-projects/components/MyProjectsSectionHeader.vue';
import { computed, ref } from 'vue';
import useI18n from '@/mixins/useI18n';
import { BcxFormField } from '@/models/BcxForm';
import BCXForm from '@/components/molecules/forms/BCXForm.vue';
import useResponsiveness from '@/mixins/useResponsiveness';
import BCXEditedIndicator from '@/components/molecules/forms/BCXEditedIndicator.vue';
import { watchDebounced, watchImmediate } from '@vueuse/core';
import useContract from '@/views/my-projects/composables/useContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContractNotes',
  setup(__props) {

const { contractDetail, submitContractNotes, isUserClient } = useContract();

const { t } = useI18n();

const { isMobileWidth } = useResponsiveness();

const hasBeenSaved = ref(0);

const fieldData = ref({
  costCenter: '',
  department: '',
  contactPerson: '',
  notes: '',
});

watchImmediate(contractDetail, (contractDetail) => {
  if (!contractDetail?.client) return;
  const userNotes = isUserClient.value ? contractDetail.client : contractDetail.contractor;
  const {
    contractNotes: notes = '',
    costcenter: costCenter = '',
    department = '',
    contactPerson = ''
  } = userNotes;
  fieldData.value = {
    notes,
    department,
    contactPerson,
    costCenter
  };
});

const formFields = computed(() => {
  const fields: BcxFormField[] = [];
  if (isUserClient.value) {
    const textOptions = {
      maxLength: 30,
      hideCharsLeft: true
    };

    fields.push(
      {
        type: 'text',
        label: `${t('contracts.contract.notes.costcenter')}`,
        name: 'costCenter',
        width: isMobileWidth.value ? '75%' : '33%',
        textOptions
      },
      {
        type: 'text',
        label: `${t('contracts.contract.notes.section')}`,
        name: 'department',
        width: isMobileWidth.value ? '100%' : '33%',
        textOptions
      },
      {
        type: 'text',
        label: `${t('contracts.contract.notes.contact')}`,
        name: 'contactPerson',
        width: isMobileWidth.value ? '100%' : '33%',
        textOptions
      }
    );
  }
  fields.push(
    {
      type: 'textarea',
      label: `${t('contracts.contract.notes.notes')}`,
      name: 'notes',
      width: '100%',
      fieldWidth: '100%',
      textareaOptions: {
        height: 64,
        enlargedHeight: 150,
        maxLength: 500
      },
      isTextareaEnlarged: isMobileWidth.value
    }
  );
  return fields;
});

const isInitialLoad = ref(true);

watchDebounced(fieldData, async () => {
  if (isInitialLoad.value) {
    isInitialLoad.value = false;
    return;
  }
  await submitContractNotes(fieldData.value);
  hasBeenSaved.value++;
}, { debounce: 500 });


return { __sfc: true,contractDetail, submitContractNotes, isUserClient, t, isMobileWidth, hasBeenSaved, fieldData, formFields, isInitialLoad, MyProjectsSectionHeader, BCXForm, BCXEditedIndicator }
}

})